import React from "react";
import { useDesign } from '../../../context/contextDesign';
import { usePayment } from '../../../context/contextPayment';
import Cards from './card';
import './style.css';

const PricingSection = () => {
  const { toggleUpgradeCard } = useDesign();
  const { loadingPayment } = usePayment();
  
  return (
    <>
      {/* Dark Transparent Background */}
      <div
        className="position-fixed top-0 start-0 w-100 h-100 z-2"
        style={{ 
          backgroundColor: 'rgba(52, 52, 52, 0.4)',
          zIndex: 1000
        }}></div>

      {/* Modal Card */}
      <div className="position-fixed top-50 start-50 translate-middle" style={{ zIndex: 1001 }}>
        <div
          className="p-4 shadow-lg rounded-4 overflow-hidden"
          style={{ 
            height: 680, 
            width: '90vw', 
            maxWidth: '1000px', 
            border: '1px solid #ccce', 
            backgroundColor: 'white' 
          }}>
          {/* Close Button */}
          {loadingPayment ? (
            ""
          ): (
            <div className="position-absolute top-0 end-0 p-3" style={{ fontSize: 20 }}>
              <i
                className="bi bi-x-lg fs-5"
                role="button"
                onClick={toggleUpgradeCard}
              />
            </div>
          )}
          <Cards />
        </div>
      </div>
    </>
  );
};

export default PricingSection;